/**
 * Shared geometry for table cells that are read ACROSS, not down.
 *
 * Project Monitor puts `LengthSplit` and the phase plan side by side, and both
 * are caption / bar / footer. A planner compares the two bars at a glance — so
 * the bars have to sit on one axis, and a bar's vertical position is exactly the
 * height of the caption above it. Two captions that merely *happen* to be the
 * same font size are one line-height change away from drifting apart, which is
 * the kind of thing that makes a table feel wrong without anybody being able to
 * say why. Reported 2026-10-29: "chiar nu-mi place ca sunt descentrate, as vrea
 * sa fie aliniate pe acceasi axa."
 *
 * Its own module rather than an export from either screen: `ProjectJobsMonitor`
 * imports `LengthSplit`, so a constant living in the former and imported by the
 * latter is a circular import — `undefined` at module-eval time, in one
 * direction only, depending on which file webpack reaches first.
 */

/** Height of the caption row above a bar. The bar's y IS this number. */
export const CAPTION_H = 18;

/** Height of the bar itself, in every column that draws one. */
export const BAR_H = 6;

/** The empty track behind a fill. One grey that works on both themes. */
export const BAR_TRACK = 'rgba(148, 163, 184, 0.25)';

export default { CAPTION_H, BAR_H, BAR_TRACK };
